import { useEffect } from "react"
import useLoginByToken from "../../queries/use-login-by-token"
import { useAuth } from "@/modules/auth/store/use-auth"
import transformUserInfo from "../../utils/transform-user-info"
import { Button } from "@/components/ui/button"

interface LoginByTokenProps {
  token: string
  redirect: string
}

export default function LoginByToken({ token, redirect }: LoginByTokenProps) {
  const { isLoading, isError, data, isSuccess, refetch } = useLoginByToken(token)
  const { logIn, setPartialToken } = useAuth()
  useEffect(() => {
    if (!isSuccess || !data) return
    const { user: userInfo, courses } = data

    if (courses.length > 0) {
      const user = transformUserInfo(userInfo)
      logIn({ token, user })
    } else {
      setPartialToken(token)

      setTimeout(() => {
        window.open(redirect, "_self")
      }, 300)
    }
  }, [isSuccess, data])

  return (
    <div className="flex size-full flex-col items-center justify-center gap-3">
      {isLoading ? (
        <p>Cargando...</p>
      ) : isError ? (
        <>
          <p>Error al cargar el usuario. Por favor, vuelve a intentar.</p>
          <Button onClick={() => refetch()}>Reintentar</Button>
        </>
      ) : null}
    </div>
  )
}
